import {
  axiosInstancePromotion,
  CustomResponseFormat,
} from "./instancePromotion";

// 제휴 진입 여부와 코드를 카카오 OAuth state 로 왕복시킨다 (풀페이지 리다이렉트 대비).
// 이 prefix 가 붙어 있으면 제휴 퍼널, 아니면 일반 프로모션 퍼널이다.
export const REFERRAL_STATE_PREFIX = "referral:";

// state 문자열에서 레퍼럴 코드를 꺼낸다. 제휴 진입이 아니면 undefined.
export const parseReferralState = (
  state: string | null
): string | undefined => {
  if (!state || !state.startsWith(REFERRAL_STATE_PREFIX)) return undefined;
  return state.slice(REFERRAL_STATE_PREFIX.length) || undefined;
};

export const REFERRAL_DOMAIN = "referral";

export const REFERRAL_SAVE_ENDPOINT = "save";
export const REFERRAL_VALIDATE_ENDPOINT = "validate";

// 혜택 유형: affiliate=제휴(크리에이터 정산 대상) / discount=단순할인
export type ReferralCodeType = "affiliate" | "discount";

// 게이트 검증 응답: isValid=유효 여부, isExpired=기간 만료 여부(만료 안내 화면 분기용),
// name=화면 노출용 제휴사 이름(코드 아님),
// endAt=혜택 종료 일시(서버 표준 "yyyy-MM-dd'T'HH:mm:ss" 문자열, 무기한이면 null), type=혜택 유형.
export type ReferralInfo = {
  isValid: boolean;
  isExpired?: boolean;
  name?: string | null;
  displayName?: string | null;
  endAt?: string | null;
  type?: ReferralCodeType | null;
};

export const referralApi = {
  saveReferralCode: (code: string) =>
    axiosInstancePromotion.post<void>(
      `${REFERRAL_DOMAIN}/${REFERRAL_SAVE_ENDPOINT}`,
      {
        code: code,
      }
    ),

  // 비인증(로그인 전) 게이트 유효성 검사 — 유효 여부 + 표시용 제휴사 이름 반환
  validate: (code: string) =>
    axiosInstancePromotion.get<CustomResponseFormat<ReferralInfo>>(
      `${REFERRAL_DOMAIN}/${REFERRAL_VALIDATE_ENDPOINT}`,
      { params: { code } }
    ),
};
